import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useDispatch, useSelector } from "react-redux";
import { UpdateAlertModalData, UpdateLargeTextModalData } from "../Store";

const LargeTextModal = ({ children }) => {
  const dispatch = useDispatch();
  const isShown = useSelector((state) => state.generalModals.largeTextModalData.isShown);
  const windowSizeCssClass = useSelector((state) => state.appMenu.screenSize);

  const handleOnHide = () => {
    dispatch(UpdateLargeTextModalData({ isShown: false }));
  };

  return (
    <Modal
      size={"lg"}
      dialogClassName={`custom-modal-dialog ${windowSizeCssClass}`}
      contentClassName={"custom-modal-content"}
      show={isShown}
      onHide={() => handleOnHide()}
    >
      <div className={"bordered"}>
        <Modal.Header className={"border-0"} closeButton></Modal.Header>

        <div className={"overflow-y-auto"} style={{ maxHeight: "65vh" }}>
          {children && <div dangerouslySetInnerHTML={{ __html: children }}></div>}
        </div>
      </div>
    </Modal>
  );
};
export default LargeTextModal;
